import React from 'react'
import { Alert, Box, Snackbar, Typography } from '@mui/material'

export const PlannerErrorSnackbar = ({ errorPlanificacion, setErrorPlanificacion }) => (
  <Snackbar
    open={Boolean(errorPlanificacion)}
    onClose={() => setErrorPlanificacion(null)}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    autoHideDuration={null}
    sx={{
      mt: 7,
      zIndex: 1600,
      width: { xs: 'calc(100% - 24px)', md: 'auto' },
      maxWidth: { xs: 'calc(100% - 24px)', md: 720 },
    }}
  >
    <Alert
      severity="error"
      variant="filled"
      onClose={() => setErrorPlanificacion(null)}
      sx={{
        alignItems: 'center',
        width: '100%',
        boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
        '& .MuiAlert-message': {
          minWidth: 0,
        },
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: 900, fontSize: '0.9rem' }}>
          {errorPlanificacion?.message}
        </Typography>
        {errorPlanificacion?.filtro && (
          <Typography sx={{ fontSize: '0.78rem', mt: 0.35, overflowWrap: 'anywhere' }}>
            Filtro: {Object.entries(errorPlanificacion.filtro)
              .map(([key, value]) => `${key}: ${value}`)
              .join(' | ')}
          </Typography>
        )}
      </Box>
    </Alert>
  </Snackbar>
)
